
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class CourseCard extends Vue {
  @Prop() dataSource: {
    id: number
    title: string
    tag: string
    cover: string
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
